import { create } from 'zustand';

import type { TimelineStage } from '../types/chatbot-message.types';

interface ExperimentChatbotState {
  /**
   * Dev / QA override: when set, pins the chatbot to a specific stage so we can
   * walk through every screenshot. When `null`, the panel uses the stage
   * derived from real experiment state via `deriveTimelineStage`.
   */
  devStageOverride: TimelineStage | null;
  setDevStageOverride: (stage: TimelineStage | null) => void;

  /** Per-experiment input drafts so flipping tabs doesn't lose typed text. */
  inputDrafts: Record<string, string>;
  setInputDraft: (experimentId: string, draft: string) => void;
  clearInputDraft: (experimentId: string) => void;
}

/** UI-only state for the experiment chatbot panel — message data still comes from queries / mocks. */
export const useExperimentChatbotStore = create<ExperimentChatbotState>((set) => ({
  devStageOverride: null,
  setDevStageOverride: (stage) => {
    set({ devStageOverride: stage });
  },

  inputDrafts: {},
  setInputDraft: (experimentId, draft) => {
    set((s) => ({ inputDrafts: { ...s.inputDrafts, [experimentId]: draft } }));
  },
  clearInputDraft: (experimentId) => {
    set((s) => {
      const next = { ...s.inputDrafts };
      Reflect.deleteProperty(next, experimentId);
      return { inputDrafts: next };
    });
  },
}));
